export default __webpack_public_path__ + "images/A4.13a7bff.png";